<template>
  <div class="certContractSign">
    <div class="certContractSign-top">
      <div class="top-con">
        <div class="container">
          <div class="certContractSign-title">
            合同签署
          </div>
          <span>订单编号：{{ order_no }}</span>
        </div>
        <div class="logo"></div>
      </div>
    </div>
    <div class="certContractSign-main">
      <div class="certContractSign-content">
        <div class="certContractSign-content-img">
          <img src="@/assets/image/Contract/certContractSign.png"/>
        </div>
        <div class="certContractSign-content-text">
          <div>法大大实名认证已通过</div>
          <div>请点击继续签署合同</div>
        </div>
        <div class="certContractSign-btn">
          <el-button type="primary" @click="goSign" class="sub">去签署</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {apiContractSellerInformationLink} from "../../request/API";

export default {
  name: 'certContractSign',
  data() {
    return {
      order_no: '',
      url: '',
      p: "",
    }
  },
  created() {
    this.order_no = this.$route.query.o
    this.p = this.$route.query.p
    apiContractSellerInformationLink({
      p: this.p
    }).then(res => {
      this.url = res.data.url
    })
  },
  methods: {
    goSign() {
      if(this.url){
        location.href = this.url
      } else {
        location.href = `${process.env.VUE_APP_WEBSITE}`
      }
    },
  },
}
</script>

<style lang="less" scoped>
@import "./styles/contractFormPage.less";

.contract-form-page(
  72px,
  certContractSign,
  certContractSign-top,
  certContractSign-main,
  certContractSign-btn
);
.contract-feedback-layout(certContractSign, certContractSign-main, certContractSign-content, 650px, 520px);

.certContractSign {
  min-height: 100vh;

  &-title {
    font-size: 24px;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    margin: 0 0 8px;
  }

  &-content {
    &-img {
      img {
        display: block;
        width: 211px;
        height: 249px;
        object-fit: contain;
      }
    }

    &-text {
      margin: 42px 0 0;

      div {
        text-align: center;
      }

      div:first-of-type {
        font-size: 20px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: var(--text-main, #1A1D24);
        margin: 0 0 4px;
      }

      div:last-of-type {
        font-size: 16px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: var(--text-secondary, #5A5F6B);
      }
    }
  }

  &-main {
    .certContractSign-btn {
      margin-top: 60px;

      button.sub {
        margin-left: 0;
        background-color: var(--primary);
        border-color: var(--primary);
        color: #fff;
        border-radius: 3px;

        &:hover,
        &:focus {
          background-color: var(--primary-hover);
          border-color: var(--primary-hover);
          color: #fff;
        }
      }
    }
  }

  & &-main &-btn {
    button.sub {
      margin-left: 0;
    }
  }

  @media screen and (max-width: 900px) {
    &-title {
      font-size: 22px;
    }

    &-content {
      padding: 0 24px;

      &-img {
        img {
          width: 145px;
          height: 171.11px;
        }
      }
    }
  }

  @media screen and (max-width: 500px) {
    &-title {
      font-size: 20px;
    }

    &-btn {
      width: 80vw;
    }

    &-content {
      &-text {
        margin-top: 28px;
      }
    }
  }
}
</style>
